export default __webpack_public_path__ + "static/media/BillPay-Void_Dark2.3c8e0df4.svg";